/**
 * ลงทะเบียน service worker ของ shell
 *
 * Service worker cache เฉพาะ static shell asset เท่านั้น (ดู `public/sw.js`)
 * ไม่มี local ledger และไม่มี business mutation queue ใน Work Order นี้
 */

export interface RegisterServiceWorkerOptions {
  /** เปิดเฉพาะ production build — dev server ใช้ HMR */
  readonly enabled: boolean;
  readonly scriptUrl?: string;
  readonly onError?: (error: unknown) => void;
}

export function registerServiceWorker(options: RegisterServiceWorkerOptions): void {
  const { enabled, scriptUrl = '/sw.js', onError } = options;

  if (!enabled) {
    return;
  }
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return;
  }
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(scriptUrl, { scope: '/' }).catch((error: unknown) => {
      onError?.(error);
    });
  });
}
